import React, {Component} from 'react';
import QuienesSomos from '.';
import Detalle from './Detalle'

class WithData extends Component{
  constructor(){
    super();
    this.state ={
      text: "",
      staffAll : [],
      staffResponsables : [],
      staffCatedraOMC : [],
      staffPropIntel : []
    }
  }

  componentDidMount(){
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer pat6jAlLNNigrNUEE.b55c43506b2f3705ce219e322d78ae26763b9233d82db88ffeacfab50cf55d98");
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/QuienesSomos-Contenido", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      this.setState({
        text:data.records[0].fields.Descripcion
      });
    })
    .catch(error=>{
      console.error(error);
    })

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/QuienesSomos-Responsables", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      var arrResponsables = [];
      var arrCatedraOMC = [];
      var arrPropIntel = [];
      var staffAll = [];
      var objeto = {};
      data.records.forEach(responsable => {
        if (responsable.fields.Activo) {
          // el objeto obtiene datos del empleado en el array
          objeto = {
            id : responsable.id,
            nombre : responsable.fields.Nombre,
            cargo : responsable.fields.Cargo.length > 65 ? responsable.fields.Cargo.substring(0, 63) + "..." :  responsable.fields.Cargo,
            imagen : responsable.fields.Imagen[0].thumbnails.large.url,
            cv : responsable.fields.CV,
            seccion : responsable.fields.Seccion
          }
          staffAll.push(objeto)
          // el objeto es pusheado al arreglo correspondiente segun su seccion
          if (responsable.fields.Seccion == "Responsables") {
            arrResponsables.push(objeto);
            /*
            arrResponsables[0] = responsable.fields.Nombre == "VALENTINA DELICH" ? objeto : arrResponsables[0];
            arrResponsables[1] = responsable.fields.Nombre == "SOL TERLIZZI" ? objeto : arrResponsables[1];
            arrResponsables[2] = responsable.fields.Nombre == "ROCÍO TERLIZZI" ? objeto : arrResponsables[2];
            */
          } else if (responsable.fields.Seccion == "Investigadores Cátedra OMC") {
            arrCatedraOMC.push(objeto);
          } else {
            arrPropIntel.push(objeto);
          }
          
        }
      });
      // el state de WithData es modificado una sola vez
      this.setState({
        staffResponsables : arrResponsables.reverse(),
        staffCatedraOMC : arrCatedraOMC,
        staffPropIntel : arrPropIntel,
        staffAll : staffAll
      });
      
    })
    .catch(error=>{
      console.error(error);
    })

  }

  render(){

    let id = this.props.match.params.id
    if(id && this.state.staffAll.length > 0){

      const staffMember = this.state.staffAll.filter(staff=>staff.id === id);
      window.scrollTo(0, 400)

      return (<Detalle location={staffMember} />);

    } else {
      return (
        <div>
          <QuienesSomos text={this.state.text} 
                   staffResponsables={this.state.staffResponsables}
                   staffCatedraOMC={this.state.staffCatedraOMC}
                   staffPropIntel={this.state.staffPropIntel}
          />
        </div>
      );  
    }
  }
}

export default WithData;
